const uiColors = {
  overlay: {
    default: 'rgba(27, 0, 74, 0.8)',
  },
  primary: {
    default: 'rgba(125, 74, 213, 0.6)',
    hover: 'rgba(140, 81, 242, 0.8)',
    pressed: 'rgba(85, 28, 184,  0.8)',
    disabled: 'rgba(85, 28, 184, 0.2)',
  },
  secondary: {
    default: 'rgba(255, 47, 109, 0.8)',
    hover: 'rgba(255, 44, 107, 0.8)',
    pressed: 'rgba(224, 0, 67, 0.8)',
  },
  toggled: {
    default: '#F00073',
  },
  panel: {
    default: 'rgba(27, 0, 74, 0.6)',
  }
};

const uiConfig = {
  H: {
    colors: uiColors,
    offsets: {
      right_panel: { top: 0, left: -11 },
      bottom_panel: { top: -48, left: 90 },
    },
  },

  V: {
    colors: uiColors,
    offsets: {
      top: 30,
      left: 0,
    },
  }
};

export {
  uiConfig,
}
